export default "__VITE_ASSET__DBh1TAuO__"